module.exports = __webpack_public_path__ + "img/shar_no.785bbd6d.png";